<template>
  <div class="branded-layout">
    <header class="branded-header">
      <img
        v-if="company.logo"
        :alt="company.name"
        :src="company.logo"
        class="company-logo"
      />
      <h1 v-else>{{ company.name }}</h1>
      <p class="powered-by">
        Safety Powered By <img src="@/assets/salus-gray.png" alt="SALUS" />
      </p>
    </header>
    <slot />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BrandedLayout',
  computed: {
    ...mapGetters({
      company: 'brandingCompany',
    }),
  },
}
</script>

<style scoped lang="sass">
.branded-layout
  padding-top: 16px
  .company-logo
    font-size: 1.5rem
    max-width: 150px
    text-align: center
    width: 100%

.branded-header,
.powered-by
  align-items: center
  display: flex
  justify-content: center

.branded-header
  margin-bottom: 16px
  flex-direction: column
  row-gap: 8px
  text-align: center

.powered-by
  color: $darkGrey
  column-gap: 8px
  font-size: 0.75rem
  margin: 0
  img
    flex-shrink: 0
    width: 82px

.theme--dark
  .branded-header h1
    color: $white !important
  .powered-by
    color: $textMuted !important
</style>
